module.exports = __webpack_public_path__ + "static/img/sample-docsignature-template.ef59aa0e.png";